import { render, staticRenderFns } from "./NotPublicFoundPage.vue?vue&type=template&id=f16411fc&"
import script from "./NotPublicFoundPage.vue?vue&type=script&lang=js&"
export * from "./NotPublicFoundPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports